import { useSyncExternalStore } from 'react';
import { getLocationPathname, subscribeToLocationChange } from '../webUtils/locationStore';

export const useLocationPathname = (): string => {
  return useSyncExternalStore(subscribeToLocationChange, getLocationPathname);
};
